import { render, staticRenderFns } from "./FImage.vue?vue&type=template&id=6ff6795c&scoped=true&"
import script from "./FImage.vue?vue&type=script&lang=js&"
export * from "./FImage.vue?vue&type=script&lang=js&"
import style0 from "./FImage.vue?vue&type=style&index=0&id=6ff6795c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff6795c",
  null
  
)

component.options.__file = "FImage.vue"
export default component.exports